export const getEditOrCreate = (isCreate: boolean) =>
  `${isCreate ? 'Create' : 'Edit'}`;
